var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"compliance-doc site hfeed",attrs:{"id":"app"}},[_c('HeadNav',{attrs:{"selectedLanguage":"en","page":_vm.page}}),_vm._v(" "),_c('div',{staticClass:"site-content compliance-doc__wrap",attrs:{"id":"content"}},[_c('main',{staticClass:"compliance-doc__main"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }